// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"a71a9a9d","385":"c6ce1ca1","453":"cd23d7d8","734":"222d02ff","828":"a9226858","836":"847608cc"}[chunkId] + ".chunk.js";
};